export default "__VITE_ASSET__2663f28b__"